// import React from "react";
// import { Link } from "react-router-dom";

// const ImportConfirmModal = ({ optionLabel, onCancel, onConfirm }) => {
//   const handleDownload = () => {
//   const data = [
//     [
//       "firstname",
//       "lastname",
//       "company",
//       "designation",
//       "emailaddresses",
//       "phonenumbers",
//       "instagram",
//       "twitter",
//       "linkedin",
//       "facebook",
//       "telegram",
//     ],
//     [
//       "John",
//       "Doe",
//       "TechCorp",
//       "Software Engineer",
//       "john.doe@example.com",
//       "1234567890",
//       "https://instagram.com/johndoe",
//       "https://twitter.com/johndoe",
//       "https://linkedin.com/in/johndoe",
//       "https://facebook.com/johndoe",
//       "https://t.me/johndoe",
//     ],
//   ];

//   const csvContent =
//     "data:text/csv;charset=utf-8," +
//     data.map((row) => row.join(",")).join("\n");

//   const downloadLink = document.createElement("a");
//   downloadLink.href = encodeURI(csvContent);
//   downloadLink.download = "sample.csv";
//   downloadLink.click();
// };
//   return (
//     <div className="modal fade" id="import_confirm_modal" role="dialog">
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-body">
//             <div className="text-center">
//               <div className="avatar avatar-xl bg-primary-light rounded-circle mb-3">
//                 <i className="ti ti-upload fs-36 text-primary" />
//               </div>
//               <h4 className="mb-2">Import Contacts?</h4>
//               <p className="mb-0">
//                 You are about to import contacts using <b>{optionLabel}</b>.
//                 <br />
//                 Do you want to continue?
//               </p>
//               <div className="d-flex align-items-center justify-content-center mt-4">
//                 <Link
//                   to="#"
//                   className="btn btn-light me-2"
//                   data-bs-dismiss="modal"
//                   onClick={onCancel}
//                 >
//                   Cancel
//                 </Link>
//                 <Link
//                   to="#"
//                   data-bs-dismiss="modal"
//                   className="btn btn-primary"
//                   onClick={onConfirm}
//                 >
//                   Yes, Continue
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImportConfirmModal;
    

import React from "react";
import { Link } from "react-router-dom";

const ImportConfirmModal = ({ optionLabel, onCancel, onConfirm, isProcessing }) => {
  const handleDownload = () => {
    const data = [
      [
        "firstname",
        "lastname",
        "company",
        "designation",
        "emailaddresses",
        "phonenumbers",
        "instagram",
        "twitter",
        "linkedin",
        "facebook",
        "telegram",
      ],
      [
        "John",
        "Doe",
        "TechCorp",
        "Software Engineer",
        "john.doe@example.com",
        "1234567890",
        "https://instagram.com/johndoe",
        "https://twitter.com/johndoe",
        "https://linkedin.com/in/johndoe",
        "https://facebook.com/johndoe",
        "https://t.me/johndoe",
      ],
      [
        "Jane",
        "Smith",
        "DesignHub",
        "Product Designer",
        "jane.smith@example.com",
        "9876543210",
        "https://instagram.com/janesmith",
        "https://twitter.com/janesmith",
        "https://linkedin.com/in/janesmith",
        "https://facebook.com/janesmith",
        "https://t.me/janesmith",
      ],
      [
        "Alice",
        "Johnson",
        "FinTech Ltd",
        "Data Analyst",
        "alice.johnson@example.com",
        "1122334455",
        "https://instagram.com/alicejohnson",
        "https://twitter.com/alicejohnson",
        "https://linkedin.com/in/alicejohnson",
        "https://facebook.com/alicejohnson",
        "https://t.me/alicejohnson",
      ],
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      data.map((row) => row.join(",")).join("\n");

    const downloadLink = document.createElement("a");
    downloadLink.href = encodeURI(csvContent);
    downloadLink.download = "sample_contacts.csv";
    downloadLink.click();
  };

  // Check if this is a CSV/Excel import
  const isExcelImport = optionLabel?.toLowerCase().includes("csv") || 
                        optionLabel?.toLowerCase().includes("excel");

  return (
    <div className="modal fade" id="import_confirm_modal" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text-center">
              <div className="avatar avatar-xl bg-primary-light rounded-circle mb-3">
                <i className="ti ti-upload fs-36 text-primary" />
              </div>
              <h4 className="mb-2">Import Contacts?</h4>
              <p className="mb-0">
                You are about to import contacts using <b>{optionLabel}</b>.
                <br />
                Do you want to continue?
              </p>
              
              {/* Show download sample link only for Excel/CSV import */}
              {isExcelImport && (
                <p className="text-muted mt-3 mb-0">
                  Download a{" "}
                  <span
                    onClick={handleDownload}
                    style={{ cursor: "pointer", color: "#2c5cc5", textDecoration: "underline" }}
                  >
                    sample CSV file
                  </span>
                </p>
              )}

              <div className="d-flex align-items-center justify-content-center mt-4">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={onCancel}
                  disabled={isProcessing}
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={onConfirm}
                  disabled={isProcessing}
                >
                  {isProcessing ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Processing...
                    </>
                  ) : (
                    'Yes, Continue'
                  )}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportConfirmModal;